import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import EntityCrudService from 'app/blocks/service/api/entity-service';
import {IShippingLine, ShippingLine} from 'app/blocks/model/shipping-line.model';
import {SERVER_API_URL} from 'app/app.constants';
import {Resource} from 'app/constants/resource';
import {IExpenseType} from 'app/blocks/model/expense-type.model';

@Injectable({
    providedIn: 'root'
})
export class ShippingLineService extends EntityCrudService<IShippingLine> {
    constructor(http: HttpClient) {
        super(http, Resource.SHIPPING_LINES, (obj?) => new ShippingLine(obj));
    }

    searchList(searchParams: any, limit?: number): Promise<IShippingLine[]> {
        const params: any = {
            ...searchParams,
            page: 0,
            size: limit || 50
        };

        return this.http
            .get<IShippingLine[]>(`${SERVER_API_URL}api/_search/shipping-lines`, {params})
            .toPromise()
            .then((response: IShippingLine[]) => response || []);
    }

    getAll(): Observable<IShippingLine[]> {
        return this.http.get<IShippingLine[]>(`${SERVER_API_URL}api/shipping-lines`);
    }

    getAllByIds(ids: number[]): Promise<IShippingLine[]> {
        const params = {ids: ids.join(',')};
        return this.http
            .get<IShippingLine[]>(`${SERVER_API_URL}api/shipping-lines/by-ids`, {params})
            .toPromise()
            .then((response: IShippingLine[]) => response || []);
    }

    getExpenseTypesForShippingLine(id): Promise<IExpenseType[]> {
        return this.http.get<IExpenseType[]>(`${SERVER_API_URL}api/shipping-lines/${id}/expense-types`).toPromise();
    }
}
